"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyClassItem = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../common");
const Colors_1 = require("../../../Colors");
const react_redux_1 = require("react-redux");
const academy_1 = require("../../../server/academy");
const account_1 = require("../../base/account");
const popup_1 = require("../../base/popup");
const ui_1 = require("../ui");
const EnrollPopupWrap = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    height: 560px;
    gap: 16px;

    .enroll-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        flex-shrink: 0;
    }

    .enroll-status {
        display: flex;
        flex-direction: column;
        gap: 6px;
        font-size: 14px;
        padding: 12px 16px;
        min-width: 200px;

        strong {
            font-weight: 700;
        }

        .changed {
            color: var(--color-main, #e87722);
        }
    }

    .enroll-list-wrap {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .enroll-row {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        border-bottom: 1px solid var(--color-grey-c, #e6e8ed);
        cursor: pointer;
        flex-shrink: 0;

        &:last-child {
            border-bottom: none;
        }

        p {
            font-size: 14px;
        }
    }

    .enroll-row-pinned {
        flex-shrink: 0;
        border-bottom: 1px solid var(--color-grey-c, #e6e8ed);
    }

    .enroll-scrollable {
        flex: 1;
        overflow-y: auto;
    }

    .btn-container {
        flex-shrink: 0;
    }
`;
const AcademyEnrollPopup = react_1.default.memo(({ memberId, classId, currentAcademyId, currentAcademyName, onSuccess, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const noEnrollLabel = t('academy.noEnroll');
    const [selectedId, setSelectedId] = react_1.default.useState(currentAcademyId || '');
    const [selectedName, setSelectedName] = react_1.default.useState(currentAcademyName || noEnrollLabel);
    const [searchOption, setSearchOption] = react_1.default.useState('');
    const [listData, setListData] = react_1.default.useState([]);
    const { data: academiesData, refetch } = (0, academy_1.useAcademiesList)({
        ...(searchOption ? { member: searchOption } : {}),
    });
    react_1.default.useEffect(() => {
        refetch();
    }, [searchOption]);
    react_1.default.useEffect(() => {
        if (academiesData?.items) {
            setListData(academiesData.items.map((item) => ({ id: item.academy_id, name: item.nickname })));
        }
        else {
            setListData([]);
        }
    }, [academiesData]);
    const handleSelect = (id, name) => {
        setSelectedId(id);
        setSelectedName(name);
    };
    const postMutation = (0, react_query_1.useMutation)(academy_1.postAcademyAdminMembers);
    const handleConfirm = async () => {
        if (selectedId === (currentAcademyId || '')) {
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, null);
            return;
        }
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            if (currentAcademyId) {
                await postMutation.mutateAsync({
                    academy_id: currentAcademyId,
                    class_id: classId,
                    enroll: [],
                    leave: [memberId],
                });
            }
            if (selectedId) {
                await postMutation.mutateAsync({
                    academy_id: selectedId,
                    class_id: classId,
                    enroll: [memberId],
                    leave: [],
                });
            }
            onSuccess();
            APP.eventManager.publish(popup_1.TOGGLE_POPUP, null);
        }
        catch (error) {
            alert(error);
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    return (react_1.default.createElement(EnrollPopupWrap, null,
        react_1.default.createElement("div", { className: "enroll-top" },
            react_1.default.createElement("div", { className: "enroll-status" },
                react_1.default.createElement("p", null,
                    "\uD604\uC7AC \uB4F1\uB85D\uB41C \uD559\uC6D0: ",
                    react_1.default.createElement("strong", null, currentAcademyName || noEnrollLabel)),
                react_1.default.createElement("p", null,
                    "\uBCC0\uACBD\uB41C \uD559\uC6D0:",
                    ' ',
                    react_1.default.createElement("strong", { className: selectedId !== (currentAcademyId || '') ? 'changed' : '' }, selectedName))),
            react_1.default.createElement(ui_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption })),
        react_1.default.createElement("div", { className: "enroll-list-wrap" },
            react_1.default.createElement("div", { className: "enroll-row enroll-row-pinned", onClick: () => handleSelect('', noEnrollLabel) },
                react_1.default.createElement(common_1.CheckBoxElement, { isRadioButton: true, id: "", checked: selectedId === '', handlerCheck: (itemId) => handleSelect(itemId, noEnrollLabel) }),
                react_1.default.createElement("p", null, noEnrollLabel)),
            react_1.default.createElement("div", { className: "enroll-scrollable" }, listData.map((item) => (react_1.default.createElement("div", { key: item.id, className: "enroll-row", onClick: () => handleSelect(item.id, item.name) },
                react_1.default.createElement(common_1.CheckBoxElement, { isRadioButton: true, id: item.id, checked: selectedId === item.id, handlerCheck: (itemId) => handleSelect(itemId, item.name) }),
                react_1.default.createElement("p", null, item.name)))))),
        react_1.default.createElement("div", { className: "btn-container" },
            react_1.default.createElement(common_1.Button, { text: "\uCDE8\uC18C", className: "btn-default-round btn-grey btn-xmd", onClick: () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, null) }),
            react_1.default.createElement(common_1.Button, { text: "\uD655\uC778", className: "btn-default-round btn-blue btn-xmd", onClick: handleConfirm }))));
});
exports.AcademyClassItem = react_1.default.memo(({ id }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const role = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserRole)(state));
    const userId = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserId)(state));
    const isAcademyAdmin = role === 'academy';
    const [page, setPage] = react_1.default.useState(0);
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [initialTotalCount, setInitialTotalCount] = react_1.default.useState(0);
    const [className, setClassName] = react_1.default.useState('');
    const [listData, setListData] = react_1.default.useState([]);
    const [searchOption, setSearchOption] = react_1.default.useState('');
    const countRef = react_1.default.useRef(10);
    const commonParams = {
        ...(searchOption ? { member: searchOption } : {}),
        offset: page * countRef.current,
        limit: countRef.current,
    };
    const { data: adminData, refetch: refetchAdmin } = (0, academy_1.useClassAcademyMembers)(id, commonParams);
    const { data: academyData, refetch: refetchAcademy } = (0, academy_1.useAcademyMembers)(userId, {
        ...commonParams,
        privacy_consent: true,
        class_id: id ? [id] : undefined,
    });
    const data = isAcademyAdmin ? academyData : adminData;
    const refetch = isAcademyAdmin ? refetchAcademy : refetchAdmin;
    react_1.default.useEffect(() => {
        if (id)
            refetch();
    }, [id, page, searchOption, isAcademyAdmin]);
    react_1.default.useEffect(() => {
        setPage(0);
    }, [searchOption]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / countRef.current) - 1);
                if (page !== maxPage) {
                    setPage(maxPage);
                    return;
                }
                // 이미 maxPage 인데도 0건 → 서버 total_count·items 불일치. 빈 목록 처리로 폴스루해
                // empty 문구가 노출되게 한다(기존: totalCount 잔존/음수 페이지로 빈 화면·페이지네이션 소실).
            }
            else if (items && items.length > 0) {
                setListData(items);
                setTotalCount(total_count);
                if (!searchOption)
                    setInitialTotalCount(total_count);
                if (!className)
                    setClassName(items[0].class_name);
                return;
            }
        }
        setListData([]);
        setTotalCount(0);
        if (!searchOption)
            setInitialTotalCount(0);
    }, [data, page]);
    const headTitleList = react_1.default.useMemo(() => [
        { title: 'idf', space: 1 },
        { title: 'name', space: 1 },
        ...(!isAcademyAdmin ? [{ title: 'privacyConsent', space: 1 }] : []),
        ...(!isAcademyAdmin ? [{ title: 'academyName', space: 1 }] : []),
        ...(!isAcademyAdmin ? [{ title: 'empty', space: 0.1 }] : []),
    ], [isAcademyAdmin]);
    const tableReadDataKeys = react_1.default.useMemo(() => [
        { title: 'member_idf', space: 1 },
        { title: 'member_name', space: 1 },
        ...(!isAcademyAdmin ? [{ title: 'privacy_consent', space: 1 }] : []),
        ...(!isAcademyAdmin ? [{ title: 'academy_name', space: 1 }] : []),
        ...(!isAcademyAdmin ? [{ title: 'etc', space: 0.1 }] : []),
    ], [isAcademyAdmin]);
    const openAcademyEnrollPopup = (item) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: AcademyEnrollPopup,
            componentProps: {
                memberId: item.member_id,
                classId: id,
                currentAcademyId: item.academy_id || null,
                currentAcademyName: item.academy_name || null,
                onSuccess: () => refetch(),
            },
            title: t('academy.enrollAndLeaveTitle'),
            width: 800,
            isFit: true,
        });
    };
    const renderTitle = react_1.default.useMemo(() => (react_1.default.createElement("div", { className: "table-title" },
        react_1.default.createElement("div", { className: "left-wrap" },
            react_1.default.createElement("p", { className: "title" }, t('academy.studentCount', { count: initialTotalCount.toString().padStart(2, '0') }))),
        react_1.default.createElement("div", { className: "right-wrap" },
            react_1.default.createElement(ui_1.SearchInput, { defaultValue: searchOption, setSearchOption: setSearchOption })))), [initialTotalCount, searchOption, t]);
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, t('academy.noStudentData')))), [totalCount, t]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } }, headItem.title === 'privacy_consent' ? (react_1.default.createElement("p", { className: "overText2" }, !item.academy_name
            ? '-'
            : item.privacy_consent
                ? t('academy.consentYes')
                : t('academy.consentNo'))) : headItem.title === 'etc' ? (react_1.default.createElement(common_1.Button, { option: {
                buttonAfterIcon: {
                    show: true,
                    name: 'edit',
                    color: Colors_1.Colors.tur,
                    size: 20,
                },
            }, onClick: () => openAcademyEnrollPopup(item) })) : (react_1.default.createElement("p", { className: "overText2" }, item[headItem.title] || '-')))));
    };
    return (react_1.default.createElement("div", { className: "admin-detail-info", style: { display: 'flex', flexDirection: 'column', gap: 16 } },
        className && (react_1.default.createElement("p", { style: { fontSize: 24, fontWeight: 700, color: 'var(--color-black, #101010)' } }, className)),
        react_1.default.createElement(common_1.Table, { className: "table-admin header-center", isInnerPage: true, isInfinite: false, page: page, data: listData, totalCount: totalCount, headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: renderEmpty, handlerMoreData: (p) => setPage(p) })));
});
